import {
    IRequestsAndOperationsFilter,
    RequestsAndOperations,
    IInterventionDate
} from "@edp-models/requests-and-operations";
import {Service} from "@edp-models/service.model";
import { INewRequestAndOperation } from "@edp-pages/requests-and-operations/services/new-request.service";

export interface IRequestsAndOperationsState {
    requestsAndOperations: RequestsAndOperations[];
    filters: IRequestsAndOperationsFilter[];
    services: Service[];
    loadedServices: boolean;
    loadedSlots: boolean;
    loadedRequestsAndOperations: boolean;
    localSupportList: boolean;
    associatedContract: number;
    selectedRequest: RequestsAndOperations;
    availableTimeSlots: {
        data: IInterventionDate[],
        lastAPIError: Error
    };
    selectedServiceAndMotive: INewRequestAndOperation;
    newRequestStatus: any;
}


export const initialRequestsAndOperationsState: IRequestsAndOperationsState = {
    requestsAndOperations: [],
    filters: [],
    services: [],
    loadedServices: false,
    loadedSlots: false,
    loadedRequestsAndOperations: false,
    localSupportList: true,
    associatedContract: 0,
    selectedRequest: null,
    availableTimeSlots: {
        data: null,
        lastAPIError: null
    },
    selectedServiceAndMotive: null,
    newRequestStatus: null
};
